import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Copy = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M9.2092 18.0657c-.6297 0-1.1663-.2218-1.6098-.6653s-.6652-.9801-.6652-1.6097V3.9342c0-.6297.2217-1.1663.6652-1.6098s.9801-.6652 1.6098-.6652h8.8565c.6296 0 1.1662.2217 1.6097.6652s.6653.9801.6653 1.6098v11.8565c0 .6296-.2218 1.1662-.6653 1.6097s-.9801.6653-1.6097.6653H9.2092zm-4.275 4.275c-.6297 0-1.1663-.2218-1.6098-.6653s-.6652-.9801-.6652-1.6097V7.0717c0-.3192.1097-.5886.3292-.8083.2197-.2195.4891-.3292.8083-.3292.3192 0 .5886.1097.8082.3292.2195.2197.3293.4891.3293.8083v12.994h9.994c.3191 0 .5886.1097.8082.3292.2195.2197.3293.4891.3293.8083 0 .3191-.1098.5886-.3293.8082-.2196.2195-.4891.3293-.8082.3293h-9.994z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M9.2092 18.0657c-.6297 0-1.1663-.2218-1.6098-.6653s-.6652-.9801-.6652-1.6097V3.9342c0-.6297.2217-1.1663.6652-1.6098s.9801-.6652 1.6098-.6652h8.8565c.6296 0 1.1662.2217 1.6097.6652s.6653.9801.6653 1.6098v11.8565c0 .6296-.2218 1.1662-.6653 1.6097s-.9801.6653-1.6097.6653H9.2092zm0-2.275h8.8565V3.9342H9.2092v11.8565zm-4.275 6.55c-.6297 0-1.1663-.2218-1.6098-.6653s-.6652-.9801-.6652-1.6097V7.0717c0-.3192.1097-.5886.3292-.8083.2197-.2195.4891-.3292.8083-.3292.3192 0 .5886.1097.8082.3292.2195.2197.3293.4891.3293.8083v12.994h9.994c.3191 0 .5886.1097.8082.3292.2195.2197.3293.4891.3293.8083 0 .3191-.1098.5886-.3293.8082-.2196.2195-.4891.3293-.8082.3293h-9.994z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M9.2092 18.0657c-.6297 0-1.1663-.2218-1.6098-.6653s-.6652-.9801-.6652-1.6097V3.9342c0-.6297.2217-1.1663.6652-1.6098s.9801-.6652 1.6098-.6652h8.8565c.6296 0 1.1662.2217 1.6097.6652s.6653.9801.6653 1.6098v11.8565c0 .6296-.2218 1.1662-.6653 1.6097s-.9801.6653-1.6097.6653H9.2092zm0-2.275h8.8565V3.9342H9.2092v11.8565zm-4.275 6.55c-.6297 0-1.1663-.2218-1.6098-.6653s-.6652-.9801-.6652-1.6097V7.0717c0-.3192.1097-.5886.3292-.8083.2197-.2195.4891-.3292.8083-.3292.3192 0 .5886.1097.8082.3292.2195.2197.3293.4891.3293.8083v12.994h9.994c.3191 0 .5886.1097.8082.3292.2195.2197.3293.4891.3293.8083 0 .3191-.1098.5886-.3293.8082-.2196.2195-.4891.3293-.8082.3293h-9.994z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Copy.displayName = "CopyIcon";

export { Copy, Copy as default };
